import React, { useEffect, useState } from "react";

import "../../assets/css/admin/AdminDashboard.css";

import { getAdminDashboard } from "../../adminAPI/adminDashboardApi";

import DashboardHeader from "../../components/admin/DashboardHeader";
import StatCard from "../../components/admin/StatCard";
import RecentJobs from "../../components/admin/RecentJobs";
import NewRegistrations from "../../components/admin/NewRegistrations";
import ApprovalsQueue from "../../components/admin/ApprovalsQueue";

const AdminDashboard = () => {
  const [data, setData] = useState(null);
  const token = localStorage.getItem("otoken");

  useEffect(() => {
    getAdminDashboard(token).then(setData);
  }, [token]);

  if (!data) return <div className="dashboard-loading">Loading dashboard...</div>;

  const { stats, recentJobs, newRegistrations, approvalsQueue } = data;

  return (
     <div className="admin-dashboard">
      <DashboardHeader />

      <div className="stats-grid">
        {/* <StatCard title="Total Jobs" value={stats.total_jobs} trend="+8% vs last month" color="purple" />
        <StatCard title="Active Employers" value={stats.active_employers} trend="+3% active" color="green" />
        <StatCard title="Job Seekers" value={stats.job_seekers} trend="+540 new this week" color="yellow" />
        <StatCard title="Pending Approvals" value={stats.pending_approvals} trend="Action required" color="red" /> */}
         <StatCard title="Total Jobs" value={stats.total_jobs}  color="purple" />
        <StatCard title="Active Employers" value={stats.active_employers}  color="green" />
        <StatCard title="Job Seekers" value={stats.job_seekers}  color="yellow" />
        <StatCard title="Pending Approvals" value={stats.pending_approvals}  color="red" />
      </div>

      <div className="dashboard-grid">
        <RecentJobs jobs={recentJobs} />
        <div className="side-widgets">
          <NewRegistrations data={newRegistrations} />
          <ApprovalsQueue data={approvalsQueue} />
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
